module.exports = __webpack_public_path__ + "static/media/chicken7.c8e3154c.jpg";